/*=========================================================================================
	File Name: moduleAuth.js
	Description: Auth Module
	----------------------------------------------------------------------------------------
	Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
	Author: Pixinvent
	Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/


import state from './moduleReportsState.js'
import mutations from './moduleReportsMutations.js'
import actions from './moduleReportsActions.js'
import getters from './moduleReportsGetters.js'

export default {
	namespaced: true,
	state,
	mutations,
	actions,
	getters
}
